import { Steps, Row, Col } from "antd";
import { useEffect, useState } from "react";
import {
  AddVisitInfo,
  createVisitorDef,
  VisitorData,
} from "../../types/visitTypes";
import "./AddVisit.css";
import visitService from "../../services/visitService";
import ShipAndDateSelection from "./ShipAndDateSelection";
import {
  DocumentTypeInfo,
  GenderInfo,
  ShipInfo,
  ShipPlacesInfo,
  NationalityInfo,
} from "../../types/visitTypes";
import { useHistory } from "react-router-dom";
import useAuthorizationData from "../../utils/useAuthorizationData";
import AddVisitors from "./AddVisitors";
import SubmitVisit from "./SubmitVisit";

const { Step } = Steps;

const VisitList = () => {
  const [authorizationData] = useAuthorizationData();
  const [step, setStep] = useState<number>(0);
  const [startdate, setStartDate] = useState<Date | null>(null);
  const [enddate, setEndDate] = useState<Date | null>(null);
  const [shipId, setShipId] = useState<number | null>(null);
  const [portName, setPortName] = useState<string | null>(null);
  const [eventId, setEventId] = useState<number | null>(null);
  const [previousVisitors] = useState<VisitorData[]>([]);
  const [visitors, setVisitors] = useState<VisitorData[]>([
    createVisitorDef(1),
  ]);
  const [ships, setShips] = useState<ShipInfo[]>([]);
  const [shipsPlaces, setShipsPlaces] = useState<ShipPlacesInfo[]>([]);
  const [documentType, setDocumentType] = useState<DocumentTypeInfo[]>([]);
  const [gender, setGender] = useState<GenderInfo[]>([]);
  const [nationality, setNationality] = useState<NationalityInfo[]>([]);
  const [addVisitFailed, setAddVisitFailed] = useState<boolean>(false);
  const [apiCallInProgess, setApiCallInProgress] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const onSubmitConfirm = async (e: any) => {
    setAddVisitFailed(false);
    setApiCallInProgress(true);

    const addVisitResult = await visitService.AddVisit({
      AgentId: authorizationData?.id,
      EventId: eventId,
      VisitStartDate:
        startdate != null
          ? new Date(
              Date.UTC(
                startdate.getFullYear(),
                startdate.getMonth(),
                startdate.getDate()
              )
            )
          : null,
      VisitEndDate:
        enddate != null
          ? new Date(
              Date.UTC(
                enddate.getFullYear(),
                enddate.getMonth(),
                enddate.getDate()
              )
            )
          : null,
      Visitors: visitors,
    } as AddVisitInfo);
    setApiCallInProgress(false);
    const registerSuccess = addVisitResult.status === 200;

    if (!registerSuccess) {
      const visitExistsResult = await visitService.VisitExists({
        AgentId: authorizationData?.id,
        EventId: eventId,
        VisitStartDate:
          startdate != null
            ? new Date(
                Date.UTC(
                  startdate.getFullYear(),
                  startdate.getMonth(),
                  startdate.getDate()
                )
              )
            : null,
        VisitEndDate:
          enddate != null
            ? new Date(
                Date.UTC(
                  enddate.getFullYear(),
                  enddate.getMonth(),
                  enddate.getDate()
                )
              )
            : null,
        Visitors: visitors,
      } as AddVisitInfo);
      if (
        visitExistsResult != null &&
        visitExistsResult.request?.response === "true"
      ) {
        setAddVisitFailed(false);
        history.push("/visit");
        return;
      }
    }

    if (!registerSuccess && addVisitResult.statusText?.length > 0) {
      setAddVisitFailed(true);
      return;
    }

    if (registerSuccess) {
      setAddVisitFailed(false);
      history.push("/visit");
    } else {
      setAddVisitFailed(true);
    }
  };

  const setShipAndDateStep = () => {
    setStep(0);
  };

  const setVisitorsStep = () => {
    setStep(1);
  };

  const completeShipAndDateSelection = (
    shipId: number | null,
    startdate: Date | null,
    enddate: Date | null,
    ships: ShipInfo[],
    portName: string | null,
    eventId: number | null,
    shipsPlaces: ShipPlacesInfo[]
  ) => {
    setShipId(shipId);
    setShips(ships);
    setShipsPlaces(shipsPlaces);
    setStartDate(startdate);
    setEndDate(enddate);
    setPortName(portName);
    setEventId(eventId);
    setVisitorsStep();
  };

  const setSubmitStep = (
    visitors: VisitorData[],
    gender: GenderInfo[],
    documentType: DocumentTypeInfo[],
    nationality: NationalityInfo[]
  ) => {
    setGender(gender);
    setDocumentType(documentType);
    setNationality(nationality);
    setVisitors(visitors);
    setStep(2);
  };

  function ShowStep(step: number) {
    switch (step) {
      case 2:
        return (
          <SubmitVisit
            stepBackFunction={setVisitorsStep}
            stepNextFunction={onSubmitConfirm}
            shipId={shipId}
            ships={ships}
            startdate={startdate}
            enddate={enddate}
            portName={portName}
            visitors={visitors}
            documentType={documentType}
            gender={gender}
            nationality={nationality}
            addVisitFailed={addVisitFailed}
            apiCallInProgess={apiCallInProgess}
          />
        );
      case 1:
        return (
          <AddVisitors
            stepBackFunction={setShipAndDateStep}
            stepNextFunction={setSubmitStep}
            shipId={shipId}
            ships={ships}
            startdate={startdate}
            enddate={enddate}
            portName={portName}
            previousVisitors={previousVisitors}
            visitors={visitors}
          />
        );
      default:
        return (
          <ShipAndDateSelection
            toggleFunction={completeShipAndDateSelection}
            shipId={shipId}
            startdate={startdate}
            enddate={enddate}
            ships={ships}
            portName={portName}
            eventId={eventId}
            shipsPlaces={shipsPlaces}
          />
        );
    }
  }

  return (
    <>
      <div className="add-visit">
        <Row>
          <Col span={24}>
            <div className="add-visit-steps">
              <Steps progressDot current={step}>
                <Step title="Select ship and date" />
                <Step title="Add personal data" />
                <Step title="Summary" />
              </Steps>
            </div>
            {ShowStep(step)}
          </Col>
        </Row>
      </div>
    </>
  );
};

VisitList.displayName = "Add Visit";

export default VisitList;
